module.exports = __webpack_public_path__ + "pc/img/body_basic-10.7520a6d2.png";